module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "header-element",
    attrs: {
      "id": "header-element scrolled"
    }
  }, [_c('span', {
    staticClass: "header-logo"
  }, [_c('img', {
    staticClass: "header-logo-img",
    attrs: {
      "src": require("../../../assets/winter-2019/mikmak-gradient-logo-2.png"),
      "alt": "mikmak.tv"
    },
    on: {
      "click": _vm.goHome
    }
  })]), _vm._v(" "), _c('span', {
    staticClass: "header-items"
  }, [_c('span', {
    staticClass: "header-links",
    class: [_vm.mobileMenuVisible ? 'mobile-menu-links-visible' : 'mobile-menu-links-hidden']
  }, [_c('label', {
    staticClass: "link-label"
  }, [_c('a', {
    attrs: {
      "href": _vm.getLink('#our-software')
    },
    on: {
      "click": function($event) {
        _vm.mobileMenuVisible = false
      }
    }
  }, [_vm._v("Software")])]), _vm._v(" "), _c('label', {
    staticClass: "link-label"
  }, [_c('a', {
    attrs: {
      "href": _vm.getLink('#our-solutions')
    },
    on: {
      "click": function($event) {
        _vm.mobileMenuVisible = false
      }
    }
  }, [_vm._v("Solutions")])]), _vm._v(" "), _c('label', {
    staticClass: "link-label"
  }, [_c('a', {
    attrs: {
      "href": _vm.getLink('#our-services')
    },
    on: {
      "click": function($event) {
        _vm.mobileMenuVisible = false
      }
    }
  }, [_vm._v("Services")])]), _vm._v(" "), _c('label', {
    staticClass: "link-label"
  }, [_c('a', {
    attrs: {
      "href": _vm.getLink('careers')
    },
    on: {
      "click": function($event) {
        _vm.mobileMenuVisible = false
      }
    }
  }, [_vm._v("Careers")])]), _vm._v(" "), _c('label', {
    staticClass: "link-label"
  }, [_c('a', {
    attrs: {
      "href": _vm.getLink('about')
    },
    on: {
      "click": function($event) {
        _vm.mobileMenuVisible = false
      }
    }
  }, [_vm._v("About")])])]), _vm._v(" "), _c('a', {
    staticClass: "header-contact",
    attrs: {
      "href": "#contact-footer"
    },
    on: {
      "click": function($event) {
        return _vm.getDemoEvent()
      }
    }
  }, [_vm._v("\n      Contact\n    ")]), _vm._v(" "), _c('span', {
    staticClass: "header-menu-bars",
    class: [_vm.mobileMenuVisible ? 'mobile-menu-visible' : 'mobile-menu-hidden'],
    on: {
      "click": function($event) {
        _vm.mobileMenuVisible = !_vm.mobileMenuVisible
      }
    }
  }, [_c('label', {
    staticClass: "header-menu-bar header-menu-bar-left"
  }), _vm._v(" "), _c('label', {
    staticClass: "header-menu-bar header-menu-bar-right"
  })])]), _vm._v(" "), _c('a', {
    staticClass: "get-demo-fixed-mobile",
    class: [_vm.showGetDemo ? 'get-demo-visible' : 'get-demo-hidden'],
    attrs: {
      "href": "#contact-footer"
    }
  }, [_vm._v("\n    Get a Demo\n  ")])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-79b256cd"}!./~/vue-loader/lib/selector.js?type=template&index=0!./client/components/site/Header/Header.vue
// module id = 490
// module chunks = 0